/* eslint-disable react/forbid-prop-types */
import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import * as contentActions from "../../redux/actions/contentActions";
import ItemList from "./Content-list-view";
import SearchForm from "./Search-form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

toast.configure({
  autoClose: 8000,
  draggable: false,
});

class Contents extends React.Component {
  componentDidMount() {
    const { actions } = this.props;
    actions.fetchContents(this.search);
  }

  componentDidUpdate(prevProps) {
    if (this.props.response !== prevProps.response) {
      const { actions, response } = this.props;
      if (response !== null) {
        this.myToast = toast.success(
          `${response.name} has been saved successfully`
        );
      }
      actions.fetchContents();
    }
  }

  constructor(props) {
    super(props);
    this.content = {
      category: "",
      active: true,
      position: "",
      title: "",
      details: "",
      attachments: [],
    };

    this.activePage = 1;
    this.search = {
      category: "",
      title: "",
      page: this.activePage
    };

    this.myToast = null;
  }

  handleChange = (event) => {
    const { value, name } = event.target;
    if (name === "attachments") {
      this.content[name].push(value);
    } else if (name === "active") {
      //this.content[name] = { id: value };
    } else {
      this.content[name] = value;
    }
  };

  handleSearchChange = (event) => {
    const { value, name } = event.target;
    this.search[name] = value;
  };

  handleNewClick = (event, content) => {
    event.preventDefault();
  };

  handleSearch = (event) => {
    const { actions } = this.props;
    actions.fetchContents(this.search);
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { actions } = this.props;
    actions.createContent(this.content);
  };

  handleUpdate = (event) => {
    event.preventDefault();
    const { actions } = this.props;
    actions.updateContent(this.content);
  };

  handlePageClick = (pageNumber) => {
    this.activePage = pageNumber;
    this.search.page = pageNumber;
    const { actions } = this.props;
    actions.fetchContents(this.search);
  };

  closeModal = () => {
    const { actions } = this.props;
    actions.hideModal();
  };

  render() {
    const {
      contents,
      subjects,
      forms,
      totalRecords,
      users,
      isLoadingContents = true,
      showModal = true,
      error = "",
      content = {
        category: "",
        title: ""
      },
    } = this.props;
    
    const visibility = showModal ? "invisible" : "invisible";

    if (error.length > 0) {
      this.myToast = toast.error(error);
    }

    return (

      <Fragment>
        <div className="blue-strip">
          <div className="row">
            <div className="col-10">
              <SearchForm
                content={this.search}
                handleNewClick={this.handleNewClick}
                handleSubmit={this.handleSearch}
                handleChange={this.handleSearchChange}
              />
            </div>
            <div className="col-2">
              <div className="edit-content">
                <Link
                    to={{
                      pathname: "/contents/new/"
                    }}
                    className="custom-btn d-inline-flex align-items-center m-2 m-sm-0"
                    >
                    <i className="fa fa-plus"></i> New
                </Link>
              </div>              
            </div>
          </div>
        </div>
        <div className="content-list"  style={{zIndex:100}}>
          <ItemList contents={contents} isLoading={isLoadingContents} categories={subjects} handlePageClick={this.handlePageClick} activePage={this.activePage} totalItemsCount={totalRecords}/>
        </div>
      </Fragment>
    );
  }
}

Contents.propTypes = {
  actions: PropTypes.object.isRequired,
  content: PropTypes.object,
  response: PropTypes.object,
  error: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  isLoadingContents: PropTypes.bool.isRequired,
  showModal: PropTypes.bool.isRequired,
  contents: PropTypes.array.isRequired,
  totalRecords: PropTypes.number.isRequired,
  subjects: PropTypes.array.isRequired,
  users: PropTypes.array.isRequired,
};

function mapStateToProps(state) {
  return {
    contents: state.contents.contents,
    totalRecords: state.contents.totalRecords,
    subjects: state.contents.subjects,
    forms: state.contents.forms,
    users: state.contents.users,
    error: state.contents.error,
    isLoadingContents: state.contents.isLoadingContents,
    isLoading: state.contents.isLoading,
    showModal: state.contents.showModal,
    content: state.contents.content,
    response: state.contents.response,
  };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(contentActions, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(Contents);
